import { css } from '../../styles/theme';

export const StylesAC = css``;
